module.exports = __webpack_public_path__ + "static/media/feature-incoming-offer@3x.317d04be.png";